import React from 'react';
import { IconCart, IconInfo } from './BuilderUiIcons';
import { sanitizeBlendName, BLEND_NAME_MAX_LENGTH } from '../utils/blendName';
import { useBlendCartAction } from './useBlendCartAction';
import './AddToCartButton.css';

export function BlendNameField({ cart }) {
  const { blendName, setBlendName, adding } = cart;
  return (
    <div className="blend-name-section">
      <label className="blend-name-field">
        <span className="blend-name-field__label">
          Name your blend
          <span className="blend-name-field__optional">optional</span>
        </span>
        <span className="blend-name-field__hint">Printed on your label — makes it yours</span>
        <input
          type="text"
          className="blend-name-field__input"
          value={blendName}
          onChange={(e) => setBlendName(sanitizeBlendName(e.target.value))}
          maxLength={BLEND_NAME_MAX_LENGTH}
          placeholder="e.g. Sarah's Evening Calm"
          autoComplete="off"
          disabled={adding}
        />
      </label>
    </div>
  );
}

export function CartStatusMessages({ cart }) {
  const { isShopifySynced, userRatiosBlocker, error } = cart;
  return (
    <>
      {!isShopifySynced && (
        <div className="cart-info">
          <IconInfo className="cart-info-icon" />
          <span>Products are being set up. Price shown is accurate.</span>
        </div>
      )}
      {userRatiosBlocker && isShopifySynced && (
        <div className="cart-info">
          <IconInfo className="cart-info-icon" />
          <span>{userRatiosBlocker}</span>
        </div>
      )}
      {error && <div className="cart-error">{error}</div>}
    </>
  );
}

export function CartButton({ cart, className = '' }) {
  const { adding, status, disabled, tooltip, handleAddToCart } = cart;
  return (
    <button
      type="button"
      className={`builder-action add-to-cart-btn ${className}`.trim()}
      onClick={handleAddToCart}
      disabled={disabled}
      title={tooltip}
    >
      {adding ? (
        <>
          <span className="spinner" aria-hidden="true" />
          <span className="add-to-cart-btn__label">{status || 'Processing...'}</span>
        </>
      ) : (
        <>
          <IconCart className="add-to-cart-icon" />
          <span className="add-to-cart-btn__label">Add to Cart</span>
        </>
      )}
    </button>
  );
}

/** Legacy single-column purchase block (name + button). Prefer BlendPreview layout. */
function AddToCartButton(props) {
  const cart = useBlendCartAction(props);
  if (!cart.ready) return null;
  return (
    <div className="add-to-cart-section">
      <BlendNameField cart={cart} />
      <CartButton cart={cart} />
      <CartStatusMessages cart={cart} />
    </div>
  );
}

export default AddToCartButton;
export { useBlendCartAction };
